<template>
  <div>
    <div class="ss_end" v-if="!url">
       Sharing Ended
    </div>
    <div id="vxsharewindow" style="height:100vh;width:100%;overflow-y:overlay"> </div>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";

export default {
  name: "share",
  data(){
    return {
      followzero:false,
      limit:20,
      url:"-",
      mod_userid:"",
      mod_url:"-",
    };
  },
  components: {
  },
  created() {
    let vue = this;
    window.vx_set_room(vx,
       vue.$router.currentRoute.params.acc,
       vue.$router.currentRoute.params.uid);
    if (this.$router.currentRoute.params.userid == "slot0") {
       vue.followzero = true;
    } else {
       vue.followzero = false;
       vue.prs_userid = this.$router.currentRoute.params.userid;
    }
    window.wss_open(vx, {
      acc: vx.room.acc,
      room: vx.room.name,
      uid: vx.user.id,
      cred: vx.user.creds["me"],
      routes_id: "share",
      routes: {         
        auth_me: function(msg) {
          if (vx.acc == vx.room.acc &&
              vx.room.main_room == vx.user.my_room_name) {
              wss_send(vx, "auth_room", {"cred":vx.user.creds["myroom"]});
            } else {
              wss_send(vx, "auth_room", {});
            }
          },
        auth_room: function() {
          vue.do_list_room();
        },
        room: function(msg) {
          if (!wss_ishash(msg)) { return; }
          if (msg.data.kind && msg.data.kind == "shared") {
            if (msg.data.uid == vue.mod_userid) {
              // eslint-disable-next-line
              console.log("Moderator");
              vue.mod_url = msg.data.ss;
            }
            if (msg.data.uid == vue.prs_userid) {
              // eslint-disable-next-line
              console.log("Presenter");
              vue.prs_url = msg.data.ss;
            }
            vue.update_share();
          } else {
            vue.do_list_room();
          }
        },
        list_room: vue.handle_list_room,
       },
     });
  },
  methods: {
    update_share: function() {
      let vue = this;
      let url;
      if (vue.prs_url && vue.prs_url != "-") {
        url = vue.prs_url;
      } else if (vue.mod_url && vue.mod_url != "-") {
        url = vue.mod_url;
      } else {
        //console.log("StopShare");
        vx_stop_pingpong("screenshare");
        vue.url = null;
        return;
      }
      if (url != vue.url) {
         // eslint-disable-next-line
         console.log("UpdateShare");
         vue.url = url;
         window.vx_start_pingpong
             ($("#vxsharewindow"), "screenshare", url, {windowed:true});
      }
    },
    do_list_room: function() {
      window.wss_send(window.vx, "list_room", {limit:20});
    },
    handle_list_room: function(msg) {
       let vue = this;
       if (!wss_ishash(msg)) { return; }
       if (vue.followzero) {
          let prs, mod, cur;
          for (let i=0; i<msg.data.length; i++) {
            let it = msg.data[0];
            /* slot0 presenter */
            if (i==0 && it.ss && it.ss != "-") {
              prs = it;
            }
            /* first moderator */
            if (!mod && it.kind == "mod") {
              mod = it;
            }
          }
          if (mod) {
             // eslint-disable-next-line
             console.log("Moderator:"+mod.uid);
             vue.mod_userid = mod.uid;
             vue.mod_url = mod.ss;
          } else {
             vue.mod_userid = null;
             vue.mod_url = "-";
          }
          if (prs) {
             // eslint-disable-next-line
             console.log("Presenter:"+prs.uid);
             vue.prs_userid = prs.uid;
             vue.prs_url = prs.ss;
          } else {
             vue.prs_userid = null;
             vue.prs_url = "-";
          }
          vue.update_share();
       } else {
         for (let i=0; i<msg.data.length; i++) {
           let it = msg.data[i];
           if (it.uid == vue.prs_userid) {
             vue.prs_url = it.ss;
           }
         }
         vue.update_share();
       }
    },
  },
  computed: {  
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 760px;
}
.ss_end {
 margin: 2rem;
 font-size: 2rem;
 font-weight: 500;
}
</style>
